/* ============================================================ claude-cart.js
   OUR cart drawer. Opens on every add-to-cart (fetch AND XHR are hooked, the
   same trick UpCart used, so every add path is caught — theme forms, the
   glass tiles, the rope dialog) and on the header cart icon.

   THE BAR COUNTS QUALIFYING HATS, NEVER DOLLARS (Adam, 2026-08-19: "the
   rewards bar should only go up when a hat from discounted hats is added —
   beanies stickers ropes etc are not part of that"). Qualifying = product is
   in the eligible collection (data-eligible, default discount-collection-hats).
   Membership is checked against /collections/<c>/products/<handle>.js —
   200 = in, 404 = out — and cached per session, so Adam editing that
   collection in the admin retunes the bar with no code change. */
(function () {
  'use strict';
  var root = document.getElementById('claude-cart-root');
  if (!root) return;

  var drawer = document.getElementById('claude-cart');
  var scrim = document.getElementById('claude-cart-scrim');
  var eligibleCollection = root.dataset.eligible || 'discount-collection-hats';
  var baseMessage = root.dataset.message || '';
  var milestones = (root.dataset.milestones || '').split(';;').map(function (m) {
    var p = m.split('|');
    return { count: parseInt(p[0], 10) || 0, label: p[1] || '', message: p[2] || '' };
  }).filter(function (m) { return m.count > 0; });
  /* 2026-09-16 (Adam): a milestone with NO label is text-only — it changes the
     message (the 5th hat: "Unlimited 2 Hats For $70 …") but draws no segment. */
  var segments = milestones.filter(function (m) { return !!m.label; });
  /* 2026-09-16 (Adam): the line under the bar names the ACTIVE rung at every even
     count — 2, 4, 6 … 20 hats — matching the ten "N Hats For $X!" automatic
     discounts (every pair is $70; the top rung is 20). The bar itself keeps its
     two rewards. */
  var pairPrice = parseInt(root.dataset.pairPrice, 10) || 70;
  var maxRung = parseInt(root.dataset.maxRung, 10) || 20;
  function activeRungLabel(hats) {
    var n = Math.min(maxRung, Math.floor(hats / 2) * 2);
    if (n < 2) return '';
    return n + ' Hats For $' + (n / 2 * pairPrice) + ' + FREE Shipping!';
  }

  var cart = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* NUMBERS ARE THE MESSAGE (Adam, 2026-08-28: "make anything that is a
     number or a $ gets the green treatment"). Everything in the rewards
     block runs through here: the text is escaped first — these strings are
     ours, but they land via innerHTML — then every dollar figure and bare
     number is wrapped in the money green the cart already uses. */
  function greenNums(text) {
    var safe = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return safe.replace(/(\$\d[\d,]*(?:\.\d{1,2})?|\b\d+(?:\.\d+)?\b)/g,
      '<span class="ccart__num">$1</span>');
  }

  /* -------------------------------------------------- eligibility
     The REAL membership list, from our own ?view=handles endpoint
     (templates/collection.handles.liquid) — /collections/<c>/products/<p>.js
     returns 200 for ANY product under ANY collection path, so it cannot be
     trusted (it counted a hat rope as a hat). Loaded once per session. If
     the endpoint ever fails, fall back to a keyword exclusion so the bar
     still moves rather than freezing at zero. */
  var FALLBACK_EXCLUDE = /rope|sticker|decal|paddle|towel|gift|beanie/i;
  var eligibleSet = null;

  function loadEligibleSet() {
    if (eligibleSet) return Promise.resolve(eligibleSet);
    try {
      var cached = JSON.parse(sessionStorage.getItem('ccart-set') || 'null');
      if (cached && cached.c === eligibleCollection && cached.h) {
        eligibleSet = {};
        cached.h.forEach(function (h) { eligibleSet[h] = 1; });
        return Promise.resolve(eligibleSet);
      }
    } catch (e) {}
    function page(n, acc) {
      return fetch('/collections/' + eligibleCollection + '?view=handles&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          acc = acc.concat(d.handles || []);
          return n < d.pages ? page(n + 1, acc) : acc;
        });
    }
    return page(1, []).then(function (handles) {
      eligibleSet = {};
      handles.forEach(function (h) { eligibleSet[h] = 1; });
      try {
        sessionStorage.setItem('ccart-set', JSON.stringify({ c: eligibleCollection, h: handles }));
      } catch (e) {}
      return eligibleSet;
    }).catch(function () { return null; });
  }

  function hatCount(c) {
    return loadEligibleSet().then(function (set) {
      return c.items.reduce(function (sum, it) {
        var eligible = set ? !!set[it.handle] : !FALLBACK_EXCLUDE.test(it.product_title);
        return sum + (eligible ? it.quantity : 0);
      }, 0);
    });
  }

  /* -------------------------------------------------- render */
  /* The verbiage climbs the ladder with the shopper (Adam: "there should be
     verbiage on 1 hat, on 2 hats, 3 hats, 4 hats +") — each milestone block
     carries its own message for once it is hit; below the first tier the
     base message sells tier one. Captured verbatim from the UpCart bar it
     replaces, editable per tier in the section. */
  /* is a discount CODE what's actually winning in this cart? */
  function codeWinning(c) {
    if (!c) return false;
    var amt = 0;
    (c.cart_level_discount_applications || []).forEach(function (a) {
      if (a.type === 'discount_code') amt += a.total_allocated_amount || 0;
    });
    (c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.type === 'discount_code') {
          amt += a.amount || 0;
        }
      });
    });
    return amt > 0;
  }

  function renderMessage(hats) {
    /* 2026-09-16 (Adam): the message is VERBATIM — "2 Hats For $70 Plus FREE
       Shipping!" below two hats, each milestone's own line once reached, and
       "Unlimited 2 Hats For $70 Plus FREE Shipping!" from the 5th hat. No
       dollar swapping and no shipping-word stripping: with a code on, the
       reward still reads (and hits) even though the dollars then differ. */
    var msg = baseMessage;
    milestones.forEach(function (m) {
      if (hats >= m.count && m.message) { msg = m.message; }
    });
    var msgEl = drawer.querySelector('.ccart__msg');
    msgEl.innerHTML = greenNums(msg);
    msgEl.hidden = !msg;
  }

  /* `settled` = this render carries the real hat count (the interim
     renderBar(0) call never is). The pop (Adam, 2026-08-27: "when i hit a
     reward I want the bubble to pop out a little bigger and then snap
     back") fires only when a settled render crosses a NEW milestone —
     never on page load, drawer opens, or re-renders of the same state. */
  var barAchieved = -1;

  function renderBar(hats, settled) {
    renderMessage(hats);
    var bar = drawer.querySelector('.ccart__bar');
    /* 2026-09-16 (Adam): TWO rewards, counted in qualifying hats — 2 hats and
       4 hats — each "+ FREE Shipping!". A reward is earned on COUNT alone:
       with a discount code the dollars differ but the bubble still checks
       ("have the reward still hit even though the dollar amount won't
       necessarily match"). No $60 gate, no code gate. */
    var html = '';
    var prev = 0;
    var achieved = 0;
    segments.forEach(function (m) {
      var span = m.count - prev;
      var frac = span > 0 ? Math.max(0, Math.min(1, (hats - prev) / span)) : 0;
      var done = hats >= m.count;
      if (done) achieved++;
      html += '<div class="ccart__seg' + (done ? ' is-done' : '') + '">' +
        '<div class="ccart__seg-track"><div class="ccart__seg-fill" style="width:' + (frac * 100) + '%"></div></div>' +
        '<div class="ccart__seg-dot">' + (done ? '\u2713' : '') + '</div>' +
        '</div>';
      prev = m.count;
    });
    bar.innerHTML = html;
    /* 2026-09-16 (Adam): the reward's name appears only once it is hit, as a
       centered line under the bar — never a row of unearned labels. */
    var earnedEl = drawer.querySelector('.ccart__earned');
    if (earnedEl) {
      /* only the ACTIVE reward — the highest one hit — never a stack (Adam:
         "once 4 hats is hit the 2 hats goes away") */
      var active = activeRungLabel(hats);
      earnedEl.innerHTML = active ? '<p>\u2713 ' + greenNums(active) + '</p>' : '';
      earnedEl.hidden = !active;
    }
    if (settled) {
      if (barAchieved >= 0 && achieved > barAchieved) {
        var dots = bar.querySelectorAll('.ccart__seg.is-done .ccart__seg-dot');
        for (var i = barAchieved; i < achieved; i++) {
          if (dots[i]) dots[i].classList.add('is-pop');
        }
      }
      barAchieved = achieved;
    }
  }

  function renderItems(c) {
    var wrap = drawer.querySelector('.ccart__items');
    wrap.innerHTML = c.items.map(function (it, i) {
      /* was = the NORMAL price (compare-at x qty) whenever we know it, so
         the struck figure is $34.99 whether the saving comes from the
         weekend sale, a code, the ladder, or all three together. */
      var cmp = compareCache[it.variant_id] || 0;
      var was = cmp ? cmp * it.quantity : it.original_line_price;
      var now = it.final_line_price;
      /* who is actually taking money off this line: Shopify names every
         allocation (codes AND ladder tiers), and the sale itself is the
         gap between compare-at and the price Shopify starts from. */
      var reasons = [];
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = (a.discount_application || {}).title;
        if (t && reasons.indexOf(t) < 0) reasons.push(t);
      });
      /* a code or ladder tier applies ON TOP of the sale price, so it is by
         definition the deeper discount — name it alone (Adam, 2026-08-28:
         "it shouldn't say weekend discount + the code if the code is taking
         it past the weekend discount"). The sale is only named when it is
         the only thing working. */
      if (!reasons.length && cmp && cmp > it.original_price) reasons.push('Weekend Discount');
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : '';
      return '<div class="ccart__item" data-line="' + (i + 1) + '" data-handle="' + it.handle + '">' +
        '<img class="ccart__img" src="' + img + '" alt="" loading="lazy">' +
        '<div>' +
          '<p class="ccart__name">' + it.product_title + '</p>' +
          '<div class="ccart__prices">' +
            (now < was ? '<span class="ccart__was">' + money(was) + '</span>' : '') +
            '<span class="ccart__now">' + money(now) + '</span>' +
            (now < was ? '<span class="ccart__save">(Save ' + money(was - now) + ')</span>' : '') +
          '</div>' +
          (reasons.length ? '<p class="ccart__why">' + reasons.join(' + ') + '</p>' : '') +
          '<div class="ccart__item-foot">' +
            '<span class="ccart__qty">' +
              '<button type="button" data-dq aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-iq aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<button type="button" class="ccart__remove" data-rm>Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  /* The theme paints the header count ONCE at page render, so it goes stale
     the moment the cart changes by fetch — Adam saw a "1" over an empty cart.
     We own the cart now, so we own the bubble: sync it to every cart read. */
  function syncHeaderBadge(count) {
    var bub = document.getElementById('cart-icon-bubble');
    if (!bub) return;
    bub.innerHTML = count > 0
      ? '<div class="header__cart-count absolute bg-theme-text text-theme-bg text-center">'
        + '<span aria-hidden="true" class="header__cart-count-number">' + count + '</span>'
        + '<span class="visually-hidden">' + count + ' item' + (count === 1 ? '' : 's') + '</span></div>'
      : '';
  }

  /* NEVER render an invalid payload (2026-08-27, Adam: "trying to remove a
     hat and it isn't removing"): a 422 from /cart/change.js — or a
     rate-limited /cart.js — returns an error JSON with no .items, and
     rendering it poisoned `cart` so every later tap threw before any
     request was sent. The drawer looked fine and did nothing. A bad
     payload is now dropped and the real cart re-fetched, a few tries max. */
  function validCart(c) {
    return !!c && typeof c.item_count === 'number' && Array.isArray(c.items);
  }
  var badCartRetries = 0;

  function render(c) {
    if (!validCart(c)) {
      if (badCartRetries < 3) {
        badCartRetries++;
        setTimeout(refresh, 600);
      }
      return;
    }
    badCartRetries = 0;
    cart = c;
    /* the UpCart app embed is still enabled and locks body scroll for its
       (CSS-killed, invisible, uncloseable) popup on real ATC clicks —
       lift its lock every time our drawer takes over */
    document.body.classList.remove('upcartPopupShow');
    /* claude-price-preview.js listens for this: the empty-cart pricing
       preview must vanish the instant an item lands and return the
       instant the cart empties out again */
    try {
      document.dispatchEvent(new CustomEvent('ccart:state', { detail: c }));
    } catch (e) {}
    syncHeaderBadge(c.item_count);
    updateBadges();
    var empty = c.item_count === 0;
    drawer.querySelector('.ccart__count').hidden = empty;
    drawer.querySelector('.ccart__count').textContent = '• ' + c.item_count;
    drawer.querySelector('.ccart__empty').hidden = !empty;
    drawer.querySelector('.ccart__foot').hidden = empty;
    drawer.querySelector('.ccart__items').hidden = empty;
    drawer.querySelector('.ccart__rewards').hidden = empty;
    drawer.querySelector('.ccart__promo').hidden = empty;
    updatePromoMsg(c);
    if (empty) { drawer.querySelector('.ccart__addons').hidden = true; return; }
    renderAddons(c);

    renderItems(c);

    /* THE FOOTER TELLS THE SAME STORY AS THE LINES (Adam, 2026-08-28:
       "make all the math work"). Shopify's total_discount counts only what
       IT took off — codes and the ladder — and knows nothing about the
       weekend sale, which is baked into the price. The saving a shopper
       actually sees is measured from the compare-at total, so the sale is
       added in and named alongside the rest. */
    var saleOff = 0;
    (c.items || []).forEach(function (it) {
      var cmp = compareCache[it.variant_id] || 0;
      if (cmp && cmp > it.original_price) saleOff += (cmp - it.original_price) * it.quantity;
    });
    var disc = fullPriceSaving(c);
    var discRow = drawer.querySelector('.ccart__row--disc');
    discRow.hidden = disc <= 0;
    if (disc > 0) {
      var titles = [];
      (c.cart_level_discount_applications || []).forEach(function (a) { titles.push(a.title); });
      c.items.forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) {
          if (a.discount_application && titles.indexOf(a.discount_application.title) < 0) {
            titles.push(a.discount_application.title);
          }
        });
      });
      /* ONE NUMBER, PLAINLY STATED (Adam, 2026-08-28: "you are saving
         should say the amount they are actually saving from the full price
         at the bottom"). `disc` is measured from the compare-at total, so
         it already IS the saving against full price — sale, code and ladder
         tier together. The line items name what did the work; the footer
         just says how much. */
      drawer.querySelector('.ccart__disc-label').textContent = 'You Are Saving';
      drawer.querySelector('.ccart__disc-amt').textContent = '− ' + money(disc);
    }
    /* live standard shipping (Adam, 2026-08-27): the store's standard
       rule only — $3.99 under $60 (Adam, 2026-09-10; was $7.99), FREE at $60+ after discounts. The
       faster paid options remain a checkout choice. Once FREE is earned
       the over-$60 caption retires, and the TOTAL line does the math
       (Adam: "the subtotal should do math too"). */
    /* THE LIVE FREE-SHIPPING LINE (Adam, 2026-08-28) — top of the rewards
       block, above the tier message. It reads the REAL cart total, so it
       cannot over-promise the way a shipping claim baked into a tier
       message can once a code changes the arithmetic. */
    /* claude- (2026-09-10, Adam): a 100%-off code brings the cart to $0 and
       checkout ships that free, so the drawer must not quote $3.99 on it —
       FREE is earned at $60+ OR at a $0 total with items in the cart. */
    var freeShip = c.total_price >= 6000 || (c.item_count > 0 && c.total_price === 0);
    var shipLive = drawer.querySelector('.ccart__shiplive');
    if (shipLive) {
      if (!c.item_count) {
        shipLive.hidden = true;
      } else if (freeShip) {
        shipLive.textContent = 'FREE shipping unlocked!';
        shipLive.className = 'ccart__shiplive is-free';
        shipLive.hidden = false;
      } else {
        /* the DOLLARS carry the colour (Adam, 2026-08-28: "make the $
           amount green"), the words stay quiet */
        shipLive.innerHTML = greenNums(money(6000 - c.total_price)) + ' away from FREE shipping';
        shipLive.className = 'ccart__shiplive';
        shipLive.hidden = false;
      }
    }
    var shipFree = freeShip;
    var shipEl = drawer.querySelector('.ccart__ship-amt');
    if (shipEl) {
      shipEl.textContent = shipFree ? 'FREE' : money(399);
      shipEl.classList.toggle('is-free', shipFree);
      var shipNote = drawer.querySelector('.ccart__ship-note');
      if (shipNote) shipNote.hidden = shipFree;
    }
    drawer.querySelector('.ccart__subtotal').textContent =
      money(c.total_price + (shipFree ? 0 : 399));

    renderBar(0);
    hatCount(c).then(function (h) { renderBar(h, true); });
  }

  /* THE LINE'S TRUE ANCHOR IS THE COMPARE-AT (Adam, 2026-08-28: "1 hat in
     the cart with no discount should show the 34.99 crossed out and then
     29.99 Weekend Discount ... if a code is entered the original price
     should always show the 34.99"). cart.js does NOT carry
     compare_at_price, so it is fetched per handle (once, cached) and keyed
     by variant id. Until it lands the line renders on Shopify's own
     figures, so nothing ever waits on a network call. */
  var compareCache = {};      /* variant id -> compare-at cents (0 = none) */

  /* THE ONE SAVINGS NUMBER (Adam, 2026-08-28). Everything that quotes a
     saving quotes THIS: full price (compare-at) minus what they pay. The
     footer's "You Are Saving" and the promo confirmation must agree — a
     code converted to a fixed amount for the weekend takes only $3.75 off
     the SALE price, and reporting that after a "25% off" promise reads as
     broken. Measured from $34.99 it is the $8.75 the customer expects. */
  function fullPriceSaving(c) {
    if (!c) return 0;
    var save = c.total_discount || 0;
    (c.items || []).forEach(function (it) {
      var cmp = compareCache[it.variant_id] || 0;
      if (cmp && cmp > it.original_price) save += (cmp - it.original_price) * it.quantity;
    });
    return save;
  }
  function ensureCompare(c) {
    var need = {};
    (c.items || []).forEach(function (it) {
      if (compareCache[it.variant_id] === undefined) need[it.handle] = 1;
    });
    var handles = Object.keys(need);
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          (p.variants || []).forEach(function (v) {
            compareCache[v.id] = v.compare_at_price && v.compare_at_price > v.price
              ? v.compare_at_price : 0;
          });
        })
        .catch(function () {});
    })).then(function () {
      /* anything still unknown is marked 'none' so we never re-ask */
      (c.items || []).forEach(function (it) {
        if (compareCache[it.variant_id] === undefined) compareCache[it.variant_id] = 0;
      });
    });
  }

  function refresh() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        render(c);                       /* paint now */
        return ensureCompare(c).then(function () { render(c); });  /* repaint with the anchor */
      })
      .catch(function () {});
  }

  /* -------------------------------------------------- suggested add-ons
     (Adam, 2026-08-26, replacing the one-shot rope popup): lives above the
     checkout area, X-able at ANY time but never gone for the session — the
     dismissal is keyed to the cart's item count, so the next add or remove
     brings it back. Suggestions MATCH THE REWARD BAR: ladder-eligible hats
     only (same eligibleSet as the bar), drawn from the collections the
     shopper was just browsing (localStorage c3dShopCols, written by
     claude-3d.js on every glass collection page), excluding what is already
     in the cart. The price chip is the next milestone's dollar figure, so
     the card says what the bar says. */
  var colCache = {};

  function fetchColProducts(handle) {
    if (colCache[handle]) return Promise.resolve(colCache[handle]);
    return fetch('/collections/' + handle + '/products.json?limit=24')
      .then(function (r) { return r.json(); })
      .then(function (d) { colCache[handle] = d.products || []; return colCache[handle]; })
      .catch(function () { return []; });
  }

  function addonPriceChip(hats) {
    /* SAME selection logic as renderMessage — the messages are keyed to the
       tier already ACHIEVED and sell the next step, so the chip must read
       the message the bar is showing right now, not the next milestone's
       (that bug shipped for an hour: bar said $25, chips said $15). Below
       the first tier the bar pitches the bundle ("2 Hats Is Just $60"), so
       the chip pitches the same bundle via the first tier's label. */
    /* 2026-09-16: the chip is the bar's current bundle line minus the shipping
       words — "2 Hats For $70", then "4 Hats For $140", then "Unlimited 2 Hats
       For $70" — never a per-hat dollar the pair deal cannot promise. */
    var msg = baseMessage;
    milestones.forEach(function (m) {
      if (hats >= m.count && m.message) msg = m.message;
    });
    var chip = (msg || '').replace(/\s*[-+]?\s*(?:Plus\s+)?FREE Shipping!?/i, '').replace(/!+$/, '').trim();
    return chip || null;
  }

  function renderAddons(c) {
    var box = drawer.querySelector('.ccart__addons');
    var inCart = {};
    c.items.forEach(function (it) { inCart[it.handle] = 1; });
    var cols = [];
    try { cols = JSON.parse(localStorage.getItem('c3dShopCols') || '[]'); } catch (e) {}
    if (!cols.length) cols = ['thb-hats'];
    cols = cols.slice(0, 3);
    Promise.all([loadEligibleSet()].concat(cols.map(fetchColProducts))).then(function (res) {
      var set = res[0];
      /* ten of them, swiped through (Adam, 2026-08-26) */
      var MAX = 10;
      var picks = [];
      var seen = {};
      for (var ci = 1; ci < res.length && picks.length < MAX; ci++) {
        var prods = res[ci];
        for (var pi = 0; pi < prods.length && picks.length < MAX; pi++) {
          var p = prods[pi];
          if (seen[p.handle] || inCart[p.handle]) continue;
          var eligible = set ? !!set[p.handle] : !FALLBACK_EXCLUDE.test(p.title);
          if (!eligible) continue;
          var v = null;
          for (var vi = 0; vi < (p.variants || []).length; vi++) {
            if (p.variants[vi].available) { v = p.variants[vi]; break; }
          }
          if (!v || !(p.images && p.images.length)) continue;
          seen[p.handle] = 1;
          picks.push({ p: p, v: v });
        }
      }
      if (!picks.length) { box.hidden = true; return; }
      hatCount(c).then(function (hats) {
        var chip = addonPriceChip(hats);
        var row = box.querySelector('.ccart__addons-row');
        row.innerHTML = picks.map(function (pk) {
          var img = (pk.p.images[0].src || '').replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2');
          var name = pk.p.title.split(' - ').slice(0, 2).join(' - ');
          /* the chip asks the PRICING ENGINE what this hat really costs
             next (Adam, 2026-08-27: "they should function just like the
             pricing does predicting the next discount") — code vs ladder,
             whichever wins, per tile. The bar-message chip is only the
             fallback while the engine warms up. */
          var price;
          var qc = Math.round(parseFloat(pk.v.price) * 100);
          var q = window.__c3dQuoteNextHat ? window.__c3dQuoteNextHat(qc) : null;
          if (q) price = 'Add for ' + money(q.cents);
          else if (window.__c3dQuoteNextHat) price = 'Add · $' + pk.v.price;
          else price = chip || ('Add · $' + pk.v.price);
          return '<button type="button" class="ccart__addon" data-variant="' + pk.v.id + '" data-handle="' + pk.p.handle + '">' +
            '<img src="' + img + '" alt="" loading="lazy" decoding="async">' +
            '<span class="ccart__addon-name">' + name + '</span>' +
            '<span class="ccart__addon-price">' + greenNums(price) + '</span>' +
          '</button>';
        }).join('');
        box.hidden = false;
      });
    });
  }

  /* -------------------------------------------------- promo code
     (Adam, 2026-08-26): applied via the standard /discount/CODE cookie and
     honored at checkout. 2026-09-16 (Adam): codes STACK with the automatic
     "2 Hats For $70!" pair deal (every active code combines with product
     discounts), so the caveat line now says exactly that. */
  /* The confirmation line is LIVE, not a one-time toast (Adam, 2026-08-26:
     "the moment that the code becomes unusable because of the cart level
     discount is greater have it change"). The ladder is an automatic
     discount that does not stack with codes, so whenever the cart carries
     an automatic discount the saved code is beaten — say so, positively.
     Drop back below the ladder (one hat) and the line reverts, because the
     code is usable again. Re-evaluated on every render. */
  function savedPromoCode() {
    try { return sessionStorage.getItem('ccart-promo') || ''; } catch (e) { return ''; }
  }
  /* Shopify NAMES the code it actually honored — every discount
     application carries a `title` ("WELCOME20"). Reading that name is the
     only way to tell a real code from a typo, because /discount/<code>
     returns an identical 200 redirect either way and the cookie is set
     regardless (verified 2026-08-27). Returns {CODENAME: amountOff}. */
  function appliedCodes(c) {
    var out = {};
    function add(title, amt) {
      if (!title) return;
      var k = String(title).toUpperCase();
      out[k] = (out[k] || 0) + (amt || 0);
    }
    if (!c) return out;
    (c.cart_level_discount_applications || []).forEach(function (a) {
      if (a.type === 'discount_code') add(a.title, a.total_allocated_amount);
    });
    (c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var da = a.discount_application || {};
        if (da.type === 'discount_code') add(da.title, a.amount);
      });
    });
    return out;
  }
  /* a code the shopper typed that Shopify did NOT honor — held in memory
     only, so a bad code never persists into the next visit */
  var rejectedCode = '';
  function updatePromoMsg(c) {
    /* Split the CODE's own discount from the AUTOMATIC (ladder) discount —
       Shopify's /discount cookie applies the code inside the cart, so
       total_discount alone lied: a lone hat at 20% off read as "cart
       discount is greater than your code" when the discount WAS the code
       (Adam caught it at $28 on one hat, 2026-08-26).
       And the code must be matched BY NAME (Adam, 2026-08-27: "the cart
       doesnt reject a code if it isn't correct it always says applied") —
       a typo left the previous code's discount sitting in the cart, so an
       amount-only check credited the bad code with the good code's
       savings. */
    var ok = drawer.querySelector('.ccart__promo-ok');
    var codes = appliedCodes(c);
    var codeAmt = 0;
    Object.keys(codes).forEach(function (k) { codeAmt += codes[k]; });
    var autoAmt = c ? (c.total_discount || 0) - codeAmt : 0;

    /* a rejected code speaks first, and keeps speaking until the shopper
       enters one that works */
    if (rejectedCode) {
      var live = Object.keys(codes)[0];
      ok.textContent = live
        ? 'Code "' + rejectedCode + '" is not valid. Your "' + live + '" discount is still applied.'
        : 'Code "' + rejectedCode + '" is not valid. Check the spelling and try again.';
      ok.hidden = false;
      return;
    }

    var code = savedPromoCode();
    if (!code) {
      /* Shopify is holding a code this browser applied in an earlier
         session (the cookie outlives sessionStorage) — say so rather than
         leave a live discount unexplained */
      var live = Object.keys(codes)[0];
      if (live) {
        ok.textContent = 'Code "' + live + '" applied. You are saving ' + money(fullPriceSaving(c)) + '.';
        ok.hidden = false;
      } else {
        ok.hidden = true;
      }
      return;
    }
    var mine = codes[code.toUpperCase()] || 0;
    if (mine > 0) {
      ok.textContent = 'Code "' + code.toUpperCase() + '" applied. You are saving ' + money(fullPriceSaving(c)) + '.';
    } else if (!c || !c.item_count) {
      /* 2026-09-16: the "your cart discount is greater" branch is gone —
         codes stack with the pair deal, so an unhonoured code with hats in
         the cart is simply not valid for it. */
      /* nothing to discount yet — promising anything here would be the
         same lie in a quieter voice */
      ok.textContent = 'Code "' + code.toUpperCase() + '" is saved. Add a hat to use it.';
    } else {
      ok.textContent = 'Code "' + code.toUpperCase() + '" is not valid for this cart.';
    }
    ok.hidden = false;
  }

  var promoForm = drawer.querySelector('.ccart__promo-form');
  promoForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = promoForm.querySelector('.ccart__promo-in');
    var code = (input.value || '').trim();
    if (!code) return;
    var ok = drawer.querySelector('.ccart__promo-ok');
    var btn = promoForm.querySelector('.ccart__promo-go');
    btn.disabled = true; btn.textContent = '…';
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        input.value = '';
        /* REFETCH before speaking (Adam, 2026-08-27: applying WELCOME20 on
           2 hats said "cart discount is greater" until the drawer was
           reopened) — the cached cart predates the code, so its discount
           applications still showed the automatic ladder as the winner.
           A fresh /cart.js carries Shopify's real code-vs-ladder verdict;
           the delayed second read covers Shopify settling a beat late. */
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (c) {
        /* the VERDICT: did Shopify honor THIS code, by name? Two cases are
           NOT refusals and must never be treated as one:
             · an EMPTY cart has nothing to discount, so the code is parked
               (judging it here would reject every valid code a shopper
               pastes in before adding a hat), and
             · the LADDER BEATING the code — Shopify honors whichever is
               larger and simply omits the loser, so a perfectly good code
               is absent from the cart whenever the automatic discount
               wins. Calling that "not valid" is the same lie in the other
               direction (Adam hit it at 2 hats on 2026-08-27). */
        var codes = appliedCodes(c);
        var sum = 0;
        Object.keys(codes).forEach(function (k) { sum += codes[k]; });
        var honored = !!codes[code.toUpperCase()];
        var empty = !c || !c.item_count;
        var autoWins = c ? ((c.total_discount || 0) - sum) > 0 : false;
        if (honored || empty || autoWins) {
          rejectedCode = '';
          try { sessionStorage.setItem('ccart-promo', code); } catch (err) {}
        } else {
          /* a bad code never becomes the saved code, and never survives
             the session */
          rejectedCode = code.toUpperCase();
        }
        return refresh();
      })
      .then(function () { setTimeout(refresh, 900); })
      .catch(function () {
        ok.textContent = 'Could not save that code. Try again.';
        ok.hidden = false;
      })
      .then(function () { btn.disabled = false; btn.textContent = 'APPLY'; });
  });
  fetch('/cart.js').then(function (r) { return r.json(); }).then(updatePromoMsg).catch(function () {});

  /* add-ons open the GLASS PRODUCT PAGE, they never add directly (Adam,
     2026-08-27: "i don't want clicking them to add them to the cart
     automatically that will cause customer service issues i want them to
     click on it and the product glass pops up so they can view the
     product from the cart and add it from there"). The drawer closes,
     the glass PDP opens — and adding from there re-opens the drawer via
     the add hooks, so the loop closes itself. The X is gone with the
     same instruction ("not be able to click out of it"). */
  /* A SWIPE IS NOT A TAP (Adam, 2026-08-28: "i can't swipe through the
     suggested add ons without clicking an item something is funky").
     The row scrolls horizontally, and the browser still fires a click on
     whichever tile the finger lifted over — so browsing the rail opened a
     product every time. Every other rail in the glass guards this; this
     one never did. Track the drag, swallow the click it produces. */
  var addonRow = drawer.querySelector('.ccart__addons-row');
  var aDown = null, aMoved = 0;
  addonRow.addEventListener('pointerdown', function (e) {
    aDown = { x: e.clientX, y: e.clientY }; aMoved = 0;
  }, { passive: true });
  addonRow.addEventListener('pointermove', function (e) {
    if (!aDown) return;
    aMoved = Math.max(aMoved, Math.abs(e.clientX - aDown.x), Math.abs(e.clientY - aDown.y));
  }, { passive: true });
  addonRow.addEventListener('pointerup', function () { aDown = null; }, { passive: true });
  addonRow.addEventListener('pointercancel', function () { aDown = null; aMoved = 99; }, { passive: true });
  addonRow.addEventListener('click', function (e) {
    if (aMoved >= 6) { e.stopPropagation(); e.preventDefault(); aMoved = 0; }
  }, true);

  addonRow.addEventListener('click', function (e) {
    if (aMoved >= 6) { aMoved = 0; return; }
    var tile = e.target.closest && e.target.closest('.ccart__addon');
    if (!tile || !tile.dataset.handle) return;
    close();
    var path = '/products/' + tile.dataset.handle;
    if (window.__c3dGlassOpenCollection && window.__c3dGlassOpenCollection(path)) return;
    window.location.href = path;
  });

  /* -------------------------------------------------- open/close */
  /* TWO WAYS IN, ONE CART (Adam, 2026-09-02, from Vuori's added-to-bag:
     "it should show the cart as is, just in the middle of the screen to
     click out of" / "when you click on the cart it opens full screen as it
     does right now"). An ADD opens the drawer in MODAL mode — centered,
     page visible through a light scrim, outside click closes (it always
     did); the cart icon opens the full-height drawer as before. Same
     markup, same handlers; only the CSS class differs. */
  function open(mode) {
    /* the pop-out is THE cart now, from the icon too (Adam, 2026-09-02:
       "make that pop out the standard cart behavior for everything even
       when you click on the cart, I like it better"). The full-height
       drawer CSS stays in place for a fresh ask; nothing reaches it. */
    var modal = true;
    scrim.classList.toggle('is-modal', modal);
    drawer.classList.toggle('is-modal', modal);
    scrim.hidden = false; drawer.hidden = false;
    requestAnimationFrame(function () {
      scrim.classList.add('is-open'); drawer.classList.add('is-open');
    });
    refresh();
  }
  function close() {
    scrim.classList.remove('is-open'); drawer.classList.remove('is-open');
    setTimeout(function () {
      scrim.hidden = true; drawer.hidden = true;
      scrim.classList.remove('is-modal'); drawer.classList.remove('is-modal');
    }, 360);
  }
  window.claudeCartOpen = open;
  window.claudeCartToggle = function () { drawer.hidden ? open() : close(); };
  window.claudeCartOpenModal = function () { open('modal'); };

  /* LANDING ON /cart (Adam, 2026-08-27: "it reverted back to the old non
     glass cart when i went to checkout and came back"). The click
     interceptor below only catches CLICKS on cart links — returning from
     checkout is a real page load, so the theme's old cart page rendered
     underneath. The glass drawer IS the cart: on this URL the theme's
     cart section is hidden (CSS, keyed off this class) and the drawer
     opens itself. */
  var onCartPage = /^\/cart\/?$/.test(window.location.pathname);
  if (onCartPage) document.documentElement.classList.add('c3d-cartpage');

  /* Dismissing the drawer ON the cart page would reveal a deliberately
     empty page, so there it means "back to the store" instead. Only the
     explicit dismissals route this way — internal close() calls (the
     add-on tiles close the drawer to open a glass PDP) must not
     navigate. */
  function closeOrLeave() {
    if (onCartPage) { window.location.href = '/'; return; }
    close();
  }
  /* no scroll leaks to the page while the cart is up (Adam, 2026-09-02):
     any touch that moves outside the card is swallowed — iOS ignores
     overflow: hidden on the body for touch scrolling; the CSS handles
     wheel and chaining, this handles the finger */
  document.addEventListener('touchmove', function (e) {
    if (drawer.hidden) return;
    var t = e.target;
    if (t && t.closest && t.closest('#claude-cart')) return;
    if (e.cancelable) e.preventDefault();
  }, { passive: false });
  scrim.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
  drawer.querySelector('.ccart__close').addEventListener('click', closeOrLeave);
  drawer.querySelector('.ccart__collapse').addEventListener('click', closeOrLeave);
  scrim.addEventListener('click', closeOrLeave);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeOrLeave();
  });
  if (onCartPage) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', open);
    } else {
      open();
    }
  }
  drawer.querySelector('.ccart__checkout').addEventListener('click', function () {
    window.location.href = '/checkout';
  });

  /* header cart icon opens OUR drawer, capture phase beats the theme's */
  var CART_TRIGGERS = 'a[href="/cart"], a[href^="/cart?"], .header__icon--cart, .header__icon--cart-shake, .js-open-cart-drawer';
  var lastClickAt = 0;
  document.addEventListener('click', function (e) {
    lastClickAt = Date.now();
    var a = e.target.closest && e.target.closest(CART_TRIGGERS);
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);
  /* Fallback: the THEME EDITOR (and anything else that hijacks clicks for
     its own selection UI) swallows clicks after pointerup — first the cart
     icon, then CHECKOUT (Adam, 2026-08-20: "when i press checkout nothing
     happens"). Two nets, same idea: if a press never becomes a click within
     350ms, act anyway. A press only replays when NO click landed after
     it: the old "more than 340ms since the last click" test passed for a
     click that came a few ms after pointerup, so every tap fired twice
     (Adam, 2026-10-08: "removing one hat removes two"). */
  document.addEventListener('pointerup', function (e) {
    var a = e.target.closest && e.target.closest(CART_TRIGGERS);
    if (!a) return;
    var pressAt = Date.now();
    setTimeout(function () {
      if (lastClickAt < pressAt && drawer.hidden) open();
    }, 350);
  }, true);
  /* ...and the same net over every control INSIDE the drawer — checkout,
     qty steppers, remove, close — by replaying the swallowed click. */
  drawer.addEventListener('pointerup', function (e) {
    var t = e.target.closest && e.target.closest('button, a');
    if (!t) return;
    /* ...but NOT a tile the finger just dragged across: the add-on tiles
       are <button>s, so replaying their swallowed click would re-open the
       product 350ms after a swipe — the very bug the guard above fixes
       (Adam, 2026-08-28). */
    if (t.closest('.ccart__addons-row') && aMoved >= 6) return;
    var pressAt = Date.now();
    setTimeout(function () {
      if (lastClickAt < pressAt && t.isConnected) t.click();
    }, 350);
  }, true);

  /* qty / remove */
  drawer.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.ccart__item');
    if (!item || !cart) return;
    var line = parseInt(item.dataset.line, 10);
    var it = cart.items[line - 1];
    var qty = it ? it.quantity : 0;
    var next = null;
    if (e.target.closest('[data-iq]')) next = qty + 1;
    else if (e.target.closest('[data-dq]')) next = Math.max(0, qty - 1);
    else if (e.target.closest('[data-rm]')) next = 0;
    if (next === null) {
      /* not a qty/remove press: the hat itself is the link (Adam,
         2026-08-28: "the hats in the cart need to be clickable to a
         product page") — image or title opens the glass PDP, same road
         the add-on tiles take. */
      if (e.target.closest('.ccart__img, .ccart__name') && item.dataset.handle) {
        close();
        var ppath = '/products/' + item.dataset.handle;
        if (window.__c3dGlassOpenCollection && window.__c3dGlassOpenCollection(ppath)) return;
        window.location.href = ppath;
      }
      return;
    }
    item.style.opacity = '.5';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      /* by line KEY, not position: a repeated or late request for "line 2"
         hits whichever hat slid into slot 2; a stale key just fails. */
      body: JSON.stringify(it ? { id: it.key, quantity: next } : { line: line, quantity: next })
    }).then(function (r) {
      /* a 422 body is an error JSON, not a cart — see validCart above */
      if (!r.ok) throw new Error('change ' + r.status);
      return r.json();
    }).then(render).catch(function () {
      item.style.opacity = '';
      refresh();
    });
  });

  /* -------------------------------------------------- glass cart toggle
     A little frosted cart button next to every glass overlay's ✕ so the cart
     can be expanded/collapsed from anywhere in the glass. Overlays are built
     on demand, so watch for them arriving. */
  var CART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="9" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/>' +
    '<path d="M3 3h2.5l2.2 12.2a1.6 1.6 0 0 0 1.6 1.3h7.6a1.6 1.6 0 0 0 1.6-1.3L20.5 7H6"/></svg>';

  function badgeText() {
    return cart && cart.item_count > 0 ? String(cart.item_count) : '';
  }
  function updateBadges() {
    document.querySelectorAll('.ccart-glass-toggle__n').forEach(function (n) {
      var t = badgeText();
      n.textContent = t;
      n.hidden = !t;
    });
  }

  function injectToggle(ovl) {
    if (ovl.querySelector('.ccart-glass-toggle') || !ovl.querySelector('.c3d-ovl__close')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ccart-glass-toggle';
    b.setAttribute('aria-label', 'Cart');
    b.innerHTML = CART_SVG + '<span class="ccart-glass-toggle__n" hidden></span>';
    b.addEventListener('click', window.claudeCartToggle);
    ovl.querySelector('.c3d-ovl__close').insertAdjacentElement('beforebegin', b);
    if (cart) { updateBadges(); }
    else { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cart = c; updateBadges(); }); }
  }

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.classList && n.classList.contains('c3d-ovl')) injectToggle(n);
        else if (n.querySelectorAll) [].forEach.call(n.querySelectorAll('.c3d-ovl'), injectToggle);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
  [].forEach.call(document.querySelectorAll('.c3d-ovl'), injectToggle);

  /* -------------------------------------------------- add-to-cart hooks */
  var opening = false;
  function onAdd() {
    if (opening) return;
    opening = true;
    setTimeout(function () { opening = false; }, 400);
    if (!drawer.hidden) { refresh(); return; }   /* already up (either mode): just refresh */
    open('modal');
  }

  /* -------------------------------------------------- studio bridge
     When this page is FRAMED (THE STUDIO's markup pad), report scroll and
     page size to the parent so Adam's marks pin to the page content —
     "markup, scroll, markup, and you capture the entire page". Harmless
     everywhere else: only speaks when framed, and says nothing sensitive. */
  if (window.parent !== window) {
    var reportScroll = function () {
      try {
        window.parent.postMessage({
          type: 'hb-studio:scroll',
          u: location.href,
          x: window.scrollX, y: window.scrollY,
          w: document.documentElement.scrollWidth,
          h: Math.max(document.documentElement.scrollHeight,
                      document.body ? document.body.scrollHeight : 0)
        }, '*');
      } catch (e) {}
    };
    var rafPending = null;
    window.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = requestAnimationFrame(function () { rafPending = null; reportScroll(); });
    }, { passive: true });
    window.addEventListener('load', reportScroll);
    setInterval(reportScroll, 1500);
    reportScroll();
  }

  /* boot sync — replace the server-rendered badge with the truth on load */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
    if (!validCart(c)) return;
    cart = c;
    syncHeaderBadge(c.item_count);
    updateBadges();
  }).catch(function () {});

  /* any cart mutation from ANY script re-syncs the badges; adds also open
     the drawer. Without the change/clear/update net, an app emptying the
     cart would leave the header bubble lying. */
  function onMutate() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!validCart(c)) return;
      cart = c;
      syncHeaderBadge(c.item_count);
      updateBadges();
      if (!drawer.hidden) render(c);
    }).catch(function () {});
  }
  /* CART WATCHER — PASSIVE (2026-09-02). This used to wrap window.fetch
     and XMLHttpRequest.prototype.open to notice cart calls from any script.
     That works, but "hooks every network request the page makes" is the
     exact shape of a checkout skimmer, and a classifier judging shape can't
     tell the difference — and the store is carrying a Google Ads
     "Compromised Site" flag. A PerformanceObserver reads the browser's own
     resource log AFTER each request finishes: same signal, touches nothing.
     responseStatus (Chrome 109+) filters failed adds where available. */
  var CART_MUTATIONS = /\/cart\/(add|change|clear|update)(\.js)?(\?|$)/;
  function onCartResource(en) {
    var name = en.name || '';
    if (!CART_MUTATIONS.test(name)) return;
    if (typeof en.responseStatus === 'number' && en.responseStatus > 0 &&
        (en.responseStatus < 200 || en.responseStatus >= 300)) return;
    if (name.indexOf('/cart/add') > -1) onAdd(); else onMutate();
  }
  if (window.PerformanceObserver) {
    try {
      var cartWatcher = new PerformanceObserver(function (list) {
        list.getEntries().forEach(onCartResource);
      });
      cartWatcher.observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
})();
